<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <template>
          <b-row>
            <b-col sm="2">
              <b-form-group label-for="month" label="Bulan">
                <model-select
                  id="month"
                  :options="listMonth"
                  v-model="month"
                  placeholder="Bulan"
                ></model-select>
              </b-form-group>
            </b-col>

            <b-col sm="2">
              <b-form-group label-for="year" label="Tahun">
                <model-select
                  id="year"
                  :options="listYear"
                  v-model="year"
                  placeholder="Tahun"
                ></model-select>
              </b-form-group>
            </b-col>

            <b-col sm="2">
              <b-form-group label-for="cro" label="Karyawan">
                <model-select
                  id="cro"
                  :options="listEmployee"
                  v-model="myId"
                  placeholder="CRO"
                ></model-select>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label-for="customer_group" label="Grup Konsumen">
                <model-select
                  id="customer_group"
                  :options="listCustomerGroup"
                  v-model="myCustomerGroup"
                  placeholder="Grup Konsumen"
                ></model-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="12">
              <b-button
                size="sm"
                variant="stack-overflow"
                class="mr-1 btn-brand"
                @click="init"
              >
                <i class="fa fa-search"></i>
                <span>Filter</span>
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-card-body>
    </b-card>

    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <b-tabs v-if="!loading" lazy>
        <b-tab v-for="(value, key) in customer_history_list" v-bind:key="key">
          <template #title>
            {{ value.text }}
          </template>
          <history-customer
            :flag="parseInt(value.value)"
            :month="month"
            :year="year"
            :employee="myId"
            :customerGroup="myCustomerGroup"
          ></history-customer>
        </b-tab>
      </b-tabs>

      <loading v-else></loading>
    </b-card>
  </div>
</template>


<script>
import { Callout } from "@coreui/vue";
import globalTable from "@/templates/Table.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import LineExample from "@/views/charts/LineExample.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";
import BarExample from "@/views/charts/BarExample.vue";
import { ModelSelect } from "vue-search-select";
import tableTotal from "@/templates/TableTotal.vue";
import historyCustomer from "./dashboard_tab/HistoryCustomer";
import * as moment from "moment";

import _ from "lodash";

export default {
  name: "dashboard-customer-history",
  components: {
    globalTable,
    Callout,
    loading,
    ModelSelect,
    LineExample,
    DoughnutExample,
    BarExample,
    tableTotal,
    historyCustomer,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      loading: false,
      customer_history_list: [],
      total_all: [],
      listMonth: [],
      listEmployee: [],
      listCustomerGroup: [],
      listYear: [],
      myId: 'all',
      myCustomerGroup: '1',
      today: moment().format("DD"),
      year: moment().format("YYYY"),
      month: moment().format("MM"),
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    //gimana caranya biar dapet nama dari tabel total yang udah di klik
    showNameNonGT() {
      let flag = "";
      for (let i in this.customer_no_route.label) {
        if (i == this.currState) {
          flag = this.customer_no_route.label[i];
        }
      }
      return flag;
    },
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    dropdown: function () {
      this.axios
        .get("web/dropdown/dashboard-cro/")
        .then((response) => {
          this.listMonth = response.data.month;
          this.listYear = response.data.year;
          this.listEmployee = response.data.employee;
          this.listCustomerGroup = response.data.customer_group;
          this.customer_history_list = response.data.flag_week_order;

        })
        .catch((error) => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    init: function () {
      this.loading = true;
      this.axios
        .get("web/dashboard/customer_history/total-all")
        .then((response) => {
          this.total_all = response.data.total;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Dashboard Konsumen",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    //this.showDetail(0);
    this.init();
    this.dropdown();
  },
};
</script>
